import lessRequire from '../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import classname from 'classname';

lessRequire('modules/shared/pagination/bullet-control.less');

const BulletControl = ({
	paginatedComponentName,
	paginationActions,
	totalPage,
	currentPage
}) => (
	<div className="pagination-bullet-control">
		{ bullets(
			currentPage,
			totalPage,
			paginationActions.goto,
			paginatedComponentName
		) }
	</div>
);

const bullets = (
	currentPage,
	totalPages,
	gotoAction,
	paginatedComponentName
) => {
	const elements = [];
	for (let i = 1; i <= totalPages; i++) {
		elements.push(
			<span
				key={i}
				className={classname({'active': currentPage === i})}
				onClick={e => gotoAction(paginatedComponentName, i)}/>
		);
	}
	return elements;
};

BulletControl.propTypes = {
	paginatedComponentName: PropTypes.string,
	paginationActions: PropTypes.object,
	totalPage: PropTypes.number,
	currentPage: PropTypes.number
};

export default  BulletControl;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/pagination/bullet-control.js